<template>
  <div class="ly_history">
    <div class="hd"><h2 class="tit">이벤트 참여 내역</h2></div>
    <div class="bd">
      <ul class="list_area">
        <li v-for="(item, $index) in list" :key="$index">
          <div class="cell date_cell" :class="item.type !== 'loss' ? 'plus' : ''">{{ item.regDt }}</div>
          <div class="cell cont_cell" :class="item.type !== 'loss' ? 'plus' : ''">{{ item.comment }}</div>
          <div class="cell type_cell" :class="item.type !== 'loss' ? 'plus' : ''"></div>
        </li>

        <infinite-loading @infinite="infiniteHandler">
          <div slot="spinner"></div>
          <div slot="no-more"></div>
          <div slot="no-results" class="no-results">참여 내역이 없습니다.</div>
        </infinite-loading>
      </ul>
      <a class="btn_close" href="javascript:;" @click="closeHistory">창 닫기</a>
    </div>
  </div>
</template>

<script>
  import InfiniteLoading from 'vue-infinite-loading';
  export default {
    name: "ticket-history",
    components: {
      InfiniteLoading,
    },
    data() {
      return {
        page: 1,
        totalPage: 1,
        totalCount: 0,
        pageSize: 12,
        list : [],
        limit: 20,
        slices : {
          mega :"잭팟 1등 mega에 당첨 되었습니다.",
          major:"잭팟 2등 major에 당첨 되었습니다.",
          BONUS_3: "배당 보너스 x 1.03 아이템에 당첨 되었습니다.",
          minor:"잭팟 3등 minor에 당첨 되었습니다.",
          STAMP_5: "5연승 스탬프 아이템에 당첨 되었습니다.",
          mini:"잭팟 4등 mini에 당첨 되었습니다.",
          loss: "아쉽네요! 꽝 입니다",
        }
      }
    },
    methods: {
      convertComment(item){
        let comment = this.slices[item.type]
        return comment.replace(item.type, item.amount)
      },
      closeHistory(){
        this.$parent.isHistory = false;
        $('._layer_background').hide();
      },
       infiniteHandler($state) {
         this._get('/v1/event/ticket', {
           page: this.page,
         }).then(({ data }) => {
           if (data.error) {
             alert(data.message);
             $state.complete();
             this.closeHistory();
             return;
           }

           if (data.list.length) {
             this.page += 1;
             data.list.map(obj =>{

               obj['comment'] = this.convertComment(obj)
               this.list.push(obj)
             });
             $state.loaded();
           } else {
             $state.complete();
           }

           this.totalPage = data.totalPage
           this.pageSize = data.pageSize
           this.totalCount = data.totalCount

         });
      },
    },
  }
</script>




// WEBPACK FOOTER //
// src/components/event/ticket-history.vue